<template>
  <div class="claim-container">
    <div v-if="loading" class="loading-state">
      <div class="loader"></div>
      <p>Verifying invitation...</p>
    </div>
    
    <div v-else-if="error" class="error-card">
      <h3>{{ errorTitle }}</h3>
      <p>{{ errorMessage }}</p>
      <p class="sub-text">Please contact the recruiter for a new link.</p>
    </div>

    <div v-else class="profile-card">
      <div class="card-header">
        <h1>Hello, {{ candidateName }}!</h1>
      </div>
      <div class="card-body">
        <p class="invite-text">
          <strong>{{ orgName }}</strong> has shortlisted you for a role and invited you to join their talent pool.
        </p>
        
        <div class="actions">
          <button @click="acceptOpportunity" class="btn-accept">
            View Opportunity & Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: true,
      error: false,
      errorTitle: 'Link Expired or Invalid',
      errorMessage: 'The invitation link is missing a valid token.',
      candidateName: '',
      orgName: '',
      inviteData: null
    }
  },
  computed: {
    token() {
      return this.$route.query.token;
    }
  },
  async mounted() {
    // 1. Check if token exists in URL
    if (!this.token) {
      this.error = true;
      this.loading = false;
      return;
    }

    try {
      // FIX: Changed 127.0.0.1 to localhost to match your frontend domain
      // This prevents CORS errors.
      const response = await axios.get(`http://localhost:8000/api/invite-details/${this.token}`);
      
      if (response.data.valid) {
        this.inviteData = response.data;
        this.candidateName = response.data.first_name;
        this.orgName = response.data.organization_name;
      } else {
        this.error = true;
      }
    } catch (e) {
      this.error = true;
      console.error("FULL API ERROR:", e);
      
      // Better error handling to help you debug
      if (e.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          if (e.response.status === 404) {
              this.errorTitle = "Invitation Expired";
              this.errorMessage = "This link has already been used or has expired.";
          } else {
              this.errorTitle = "Server Error";
              this.errorMessage = `Status: ${e.response.status} - ${e.response.data.detail || 'Unknown error'}`;
          }
      } else if (e.request) {
          // The request was made but no response was received
          this.errorTitle = "Connection Error";
          this.errorMessage = "Could not connect to the backend server (localhost:8000). Is it running?";
      }
    } finally {
      this.loading = false;
    }
  },
  methods: {
    acceptOpportunity() {
        // Redirect to your dashboard
        this.$router.push({ 
            path: '/candidate-dashboard', 
            query: { token: this.token } 
        });
    }
  }
}
</script>

<style scoped>
/* Same styles as before */
.claim-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f6f8;
  font-family: 'Arial', sans-serif;
}

.profile-card, .error-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
  text-align: center;
  max-width: 500px;
  width: 90%;
}

.error-card h3 { color: #e74c3c; margin-bottom: 10px; }
.sub-text { color: #7f8c8d; font-size: 0.9rem; }

.card-header h1 { margin-bottom: 10px; color: #2c3e50; }
.invite-text { font-size: 1.1rem; color: #555; margin-bottom: 30px; line-height: 1.5; }

.btn-accept {
  background-color: #f1c40f;
  color: #333;
  border: none;
  padding: 15px 30px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.btn-accept:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(241, 196, 15, 0.4);
}

.loading-state {
  text-align: center;
  color: #7f8c8d;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #f1c40f;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>